export { OutputTag, Tag } from './model';
export { TagsComponent } from './tags.component';
export { MiqTagsModule } from './tags.module';
